document.addEventListener("DOMContentLoaded", function () {
  try {
    var startTime = document
      .querySelector(".product-time_cover")
      .getAttribute("data-startTime");
    var endTime = document
      .querySelector(".product-time_cover")
      .getAttribute("data-endTime");

    function updateCountdown() {
      var now = new Date().getTime();
      var end = new Date(endTime).getTime();

      var distance = end - now;

      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      var countdownElement = document.getElementById("product-hours");
      var countdownElementMin = document.getElementById("product-minutes");
      var countdownElementSec = document.getElementById("product-seconds");
      if (countdownElement) {
      document.getElementById("product-hours").innerHTML =
        hours +
        '<span class="dots-text">:</span>' +
        '<span class="timer_text">h</span>';
       }
      if (countdownElementMin) {
      document.getElementById("product-minutes").innerHTML =
        minutes +
        '<span class="dots-text">:</span>' +
        '<span class="timer_text">m</span>';
      }
       if (countdownElementSec) {
      document.getElementById("product-seconds").innerHTML =
        seconds +
        '<span class="dots-text">:</span>' +
        '<span class="timer_text">s</span>';
      }
      if (distance < 0) {
        clearInterval(x);
        if (document.getElementById("product-hours")) document.getElementById("product-hours").innerText = "0";
        if (document.getElementById("product-minutes")) document.getElementById("product-minutes").innerText = "0";
        if (document.getElementById("product-seconds")) document.getElementById("product-seconds").innerText = "0";
      }
    }

    var x = setInterval(updateCountdown, 1000);
  } catch (error) {}
});
document.addEventListener("DOMContentLoaded", function () {
  try {
    var startTime_2 = document
      .querySelector(".product-time_cover_2")
      .getAttribute("data-startTime");
    var endTime_2 = document
      .querySelector(".product-time_cover_2")
      .getAttribute("data-endTime");

    function updateCountdown() {
      var now = new Date().getTime();
      var end = new Date(endTime_2).getTime();

      var distance = end - now;

      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      document.getElementById("product-hours_2").innerHTML =
        hours +
        '<span class="dots-text">:</span>' +
        '<span class="timer_text">h</span>';
      document.getElementById("product-minutes_2").innerHTML =
        minutes +
        '<span class="dots-text">:</span>' +
        '<span class="timer_text">m</span>';
      document.getElementById("product-seconds_2").innerHTML =
        seconds +
        '<span class="dots-text">:</span>' +
        '<span class="timer_text">s</span>';

      if (distance < 0) {
        clearInterval(x);
        document.getElementById("product-hours_2").innerText = "0";
        document.getElementById("product-minutes_2").innerText = "0";
        document.getElementById("product-seconds_2").innerText = "0";
      }
    }

    var x = setInterval(updateCountdown, 1000);
  } catch (error) {}
});
document.addEventListener("DOMContentLoaded", function () {
  try {
    var startTime_3 = document
      .querySelector(".product-time_cover_3")
      .getAttribute("data-startTime");
    var endTime_3 = document
      .querySelector(".product-time_cover_3")
      .getAttribute("data-endTime");

    function updateCountdown() {
      var now = new Date().getTime();
      var end = new Date(endTime_3).getTime();

      var distance = end - now;

      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      document.getElementById("product-hours_3").innerHTML =
        hours +
        '<span class="dots-text">:</span>' +
        '<span class="timer_text">h</span>';
      document.getElementById("product-minutes_3").innerHTML =
        minutes +
        '<span class="dots-text">:</span>' +
        '<span class="timer_text">m</span>';
      document.getElementById("product-seconds_3").innerHTML =
        seconds +
        '<span class="dots-text">:</span>' +
        '<span class="timer_text">s</span>';

      if (distance < 0) {
        clearInterval(x);
        document.getElementById("product-hours_3").innerText = "0";
        document.getElementById("product-minutes_3").innerText = "0";
        document.getElementById("product-seconds_3").innerText = "0";
      }
    }

    var x = setInterval(updateCountdown, 1000);
  } catch (error) {}
});
